export default __webpack_public_path__ + "static/media/check.ebbb4f81.svg";